module.exports = __webpack_public_path__ + "img/hel_moonmhe3tokn.a91b920.png";